import baseAPI from '@/api/base';
import {
  EditMinyanimCountdown,
  GetMinyanimCountdown,
  RegisterMinyanimCountdown,
} from '@/dtos/minyanim_countdown.dto';
import {
  DELETE_MINYANIM_COUNTDOWN_URL,
  EDIT_MINYANIM_COUNTDOWN_URL,
  GET_MINYANIM_COUNTDOWN_URL,
  REGISTER_MINYANIM_COUNTDOWN_URL,
  TOGGLE_MINYANIM_COUNTDOWN_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class MinyanimCountdown {
  static getMinyanimCountdowns = async (
    getMinyanimCountdown: GetMinyanimCountdown
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_MINYANIM_COUNTDOWN_URL, {
      params: getMinyanimCountdown,
    });
    console.log('response', response);
    return response;
  };

  static registerMinyanimCountdown = async (
    registerMinyanimCountdown: RegisterMinyanimCountdown
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(
      REGISTER_MINYANIM_COUNTDOWN_URL,
      {
        ...registerMinyanimCountdown,
      }
    );
    console.log('response', response);
    return response;
  };

  static editMinyanimCountdown = async (
    editMinyanimCountdown: EditMinyanimCountdown
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(
      EDIT_MINYANIM_COUNTDOWN_URL,
      {
        ...editMinyanimCountdown,
      }
    );
    return response;
  };

  static toggleMinyanimCountdownIsActive = async (
    editMinyanimCountdown: EditMinyanimCountdown
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_MINYANIM_COUNTDOWN_IS_ACTIVE_URL,
      {
        ...editMinyanimCountdown,
      }
    );
    return response;
  };

  static deleteMinyanimCountdown = async (
    id: string
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_MINYANIM_COUNTDOWN_URL}/${id}`
    );
    return response;
  };
}

export default MinyanimCountdown;
